import { m } from "@vega-core/paraglide/messages";

import { motiveArticles } from "../data/motiveArticles";
import { motiveFaqs } from "../data/motiveFaqs";

import { ResourcesPage } from "./ResourcesPage";

export const MotiveResourcesPage = () => (
  <ResourcesPage
    articles={motiveArticles}
    description={m.localcms_resources_search_all()}
    faqSections={motiveFaqs}
    title={m.navTitles_resources()}
  />
);
